import { render, staticRenderFns } from "./PaymentUrls.vue?vue&type=template&id=6d2272fd&scoped=true&"
import script from "./PaymentUrls.vue?vue&type=script&lang=js&"
export * from "./PaymentUrls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2272fd",
  null
  
)

export default component.exports